import { environment } from '../../../environments/environment';

// Normalize domain: allow user to put with/without https and trailing slash
const rawDomain = (environment.cognito as any).domain as string | undefined;
const normalizedDomain = rawDomain ? rawDomain.replace(/^https?:\/\//, '').replace(/\/$/, '') : '';

const normalizeRedirect = (url?: string): string | undefined => {
  if (!url) return undefined;
  const trimmed = url.trim();
  if (!trimmed) return undefined;
  return trimmed.replace(/\/$/, '');
};

const runtimeOrigin =
  typeof window !== 'undefined' ? normalizeRedirect(window.location.origin) : undefined;

const configuredSignIn = normalizeRedirect(environment.redirectUrl);
const configuredSignOut = normalizeRedirect(
  environment.redirectSignOutUrl ?? environment.redirectUrl,
);

const redirectUrls = Array.from(
  new Set([runtimeOrigin, configuredSignIn, configuredSignOut].filter(Boolean) as string[]),
);

export const awsConfig: object = {
  Auth: {
    Cognito: {
      userPoolId: environment.cognito.userPoolId,
      userPoolClientId: environment.cognito.clientId,
      signUpVerificationMethod: 'code',
      loginWith: {
        email: true,
        oauth: {
          domain: normalizedDomain,
          scopes: ['openid', 'email', 'profile', 'aws.cognito.signin.user.admin'],
          redirectSignIn: redirectUrls,
          redirectSignOut: redirectUrls,
          responseType: 'code',
        },
      },
    },
  },
};
